import { render } from "./ArticleProductStandout.vue?vue&type=template&id=2da7ca8e&scoped=true"
import script from "./ArticleProductStandout.vue?vue&type=script&lang=js"
export * from "./ArticleProductStandout.vue?vue&type=script&lang=js"

import "./ArticleProductStandout.vue?vue&type=style&index=0&id=2da7ca8e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da7ca8e"]])

export default __exports__